<template>
  <div
    class="contenedorTarjetaNuevasMomento"
    v-bind:class="{ banderaSeguimiento : banderaSeguimiento, banderaTarjetaMiniaturaExpandible : banderaTarjetaMiniaturaExpandible }"
  >
    <v-card v-if="getVariablesFormularios.length!=0" id="tarjetaResumen" class="tarjeta" :class="{ lineaIzquierda : banderaSeguimiento,}">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        v-bind:class="{'elevation-2': banderaFormularioSerie}"
        :key="renderizar"
      >
        <h2 class="tituloFormulario">{{nombreFormulario}}</h2>
        <v-divider color="#3d88c4"></v-divider>
        <div class="tituloVariable" v-if="texto_introductorio">
          <p style="text-align: justify" class="mt-3 mb-0" v-html="texto_introductorio">
          </p>
        </div>
        <v-container class="grid container" v-bind:style="{gridTemplateColumns:gridTemplate}">
          <div
            v-if="variableF.visible"
            v-for="(variableF, index5) in getVariablesFormularios"
            :key="index5"
          >
            <div>
              <div
                id="DivInformacionResumen" class="pb-0"
                v-bind:style="[ variableF.tipo!='fecha'? { padding:padding } : {padding:padding}]"
              >
              <label v-if="variableF.visible"  class="tituloVariable" v-html="variableF.nombre"></label>
                <v-tooltip top max-width="300px">
                  <template v-slot:activator="{ on }">
                    <date-picker
                      v-if="variableF.tipo=='fecha'"
                      :obligatorio="variableF.obligatorio"
                      :reglasObligatorio="reglasObligatorio"
                      v-model="getVariablesFormularios[index5].valor"
                      label=""
                      v-on="on"
                    />
                    <div v-if="variableF.tipo=='lista' && variableF.lista=='si_no'" >
                      <!-- <p >{{variableF.nombre }}</p> -->
                      <v-radio-group 
                      v-model="getVariablesFormularios[index5].valor"
                      row @change="calcularTotal()">
                        <v-radio v-for="(opcion, indexOpcion) in variableF.opciones_lista" :key="indexOpcion" :label="opcion.valor"  :value="opcion.valor"></v-radio>
                      </v-radio-group>
                    </div>
                    <v-autocomplete
                      :disabled="deshabilitado || !variableF.habilitado"
                      v-if="variableF.tipo=='lista'&& variableF.lista!='si_no'"
                      v-model="getVariablesFormularios[index5].valor"
                      v-on="on"
                      :rules="variableF.obligatorio? reglasObligatorio:[]"
                      :items="variableF.opciones_lista"
                      item-text="valor"
                      placeholder="Seleccione una opción"
                      @change="posicionSeleccionLista(getVariablesFormularios,index5)"
                      class="autocomplete"
                      dense rounded
                    ></v-autocomplete>
                   
                    <v-autocomplete
                      :disabled="deshabilitado || !variableF.habilitado"
                      v-if="variableF.tipo=='array_lista'"
                      v-model="getVariablesFormularios[index5].valor"
                      v-on="on"
                      :rules="variableF.obligatorio? reglasObligatorio:[]"
                      :items="variableF.lista_seleccionada"
                      item-text="valor"
                      placeholder="Seleccione una opción"
                      @change="posicionSeleccionLista(getVariablesFormularios,index5)"
                      class="autocomplete"
                      dense rounded
                    ></v-autocomplete>
                    <template v-if="variableF.tipo=='array_lista_multiple'">
                      <v-select
                        v-model="getVariablesFormularios[index5].valor"
                        :items="getVariablesFormularios[index5].lista_seleccionada"
                        item-text="valor"
                        cols="2"
                        placeholder="Seleccione una o mas"
                        multiple
                        chips
                        @change="calcularCantidadSeleccionada(getVariablesFormularios[index5].valor,getVariablesFormularios,index5)"
                        class="autocomplete"
                        dense rounded small-chips
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index <= cantidaElementosMostrar" small class="colorChip">
                            <span>{{ item.valor }}</span>
                          </v-chip>
                          <span
                            v-if="index === cantidaElementosMostrar +1 "
                            class="grey--text caption"
                          >(+ {{ getVariablesFormularios[index5].valor.length - (cantidaElementosMostrar +1) }} opciones)</span>
                        </template>
                      </v-select>
                    </template>
                    <template v-if="variableF.tipo=='lista_numerica'">
                      <!-- <v-subheader class="pl-0 lineado" v-on="on">{{variableF.nombre}}</v-subheader> -->
                      <v-divider class="espacioDivider"></v-divider>
                      <div style="display:flex;" class="contenedorTextoLimites">
                        <label
                          class="textoLimites"
                        >{{getVariablesFormularios[index5].lim_inferior.texto}}</label>
                        <label
                          class="textoLimites"
                        >{{getVariablesFormularios[index5].lim_superior.texto}}</label>
                      </div>
                      <v-slider
                        :disabled="deshabilitado || !variableF.habilitado"
                        v-model="getVariablesFormularios[index5].valor"
                        :thumb-size="20"
                        thumb-label="always"
                        :min="getVariablesFormularios[index5].lim_inferior.valor"
                        :max="getVariablesFormularios[index5].lim_superior.valor"
                        :tick-labels="arrayNumeros"
                        tick-size="2"
                        class="tamanoSlider mt-5"
                        color="#b3d4fc"
                        track-color="grey"
                        @input="calcularNumeros(getVariablesFormularios[index5].lim_superior.valor,getVariablesFormularios[index5].lim_inferior.valor)"
                      ></v-slider>
                    </template>

                    <template v-if="variableF.tipo=='lista_multiple'">
                      <v-select
                        class="autocomplete"
                        v-model="getVariablesFormularios[index5].valor"
                        :items="getVariablesFormularios[index5].opciones_lista"
                        item-text="valor"
                        cols="2"
                        placeholder="Seleccione una o mas"
                        multiple
                        chips
                        @change="calcularCantidadSeleccionada(getVariablesFormularios[index5].valor)"
                        rounded dense small-chips
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index <= cantidaElementosMostrar" small class="colorChip">
                            <span>{{ item.valor }}</span>
                          </v-chip>
                          <span
                            v-if="index === cantidaElementosMostrar +1 "
                            class="grey--text caption"
                          >(+ {{ getVariablesFormularios[index5].valor.length - (cantidaElementosMostrar +1) }} opciones)</span>
                        </template>
                      </v-select>
                    </template>  
                    <v-text-field
                      :disabled="deshabilitado || !variableF.habilitado"
                      v-if="variableF.tipo=='numero' && !variableF.ecuacion"
                      v-model="getVariablesFormularios[index5].valor"
                      v-on="on"
                      type="number"
                      placeholder="Escriba aquí"
                      :rules="variableF.obligatorio? reglasObligatorio:[]"
                      required
                      class="inputNumero" rounded dense
                      @change="calcularTotal()"

                    ></v-text-field>
                    <v-text-field
                      :disabled="disabledTotal"
                      v-if="variableF.ecuacion && disabledTotal"
                      v-model="calculateTotal"
                      v-on="on"
                      type="number"
                      placeholder="Escriba aquí"
                      :rules="variableF.obligatorio? reglasObligatorio:[]"
                      required
                      class="inputNumero" rounded dense
                    ></v-text-field>
                    <template v-else-if="variableF.tipo === 'lista_radio_button'">
                      <h3 class="nombreRadioGroup" v-html="variableF.nombre"></h3>
                      <v-radio-group v-model="getVariablesFormularios[index5].valor" :disabled="deshabilitado" row  >
                        <v-radio color="primary" v-for="(opcionRadioButton, index3) in variableF.opciones_lista"
                            :key="index3" :label="opcionRadioButton.valor" :value="opcionRadioButton.valor" @change="calcularTotal()">
                        </v-radio>
                      </v-radio-group>
                    </template>
                   
                    <v-textarea
                      :disabled="deshabilitado || !variableF.habilitado"
                      rows="1"
                      auto-grow
                      v-if="variableF.tipo=='double_string'"
                      placeholder="Escriba aquí"
                      v-model="getVariablesFormularios[index5].valor"
                      v-on="on"
                      :rules="variableF.obligatorio? reglasObligatorio:[]"
                      required
                      class="inputTexto" rounded dense
                    ></v-textarea>

                    <v-textarea
                      :disabled="deshabilitado || !variableF.habilitado"
                      rows="1"
                      auto-grow
                      v-if="variableF.tipo=='string'"
                      placeholder="Escriba aquí"
                      v-model="getVariablesFormularios[index5].valor"
                      v-on="on"
                      :rules="variableF.obligatorio? reglasObligatorio:[]"
                      required
                      class="inputTexto" rounded dense
                      style="heigt:min-content"
                    ></v-textarea>
                    <youtube
                      v-if="variableF.multimedia"
                      :video-id="variableF.multimedia"
                      ref="youtube"
                      @playing="playing(index5)"
                    ></youtube>
                  </template>
                  <span v-html="variableF.nombre"></span>
                </v-tooltip>
                <v-tooltip v-if="variableF.imagenAyuda" bottom max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-icon color="warning" v-on="on">info</v-icon>
                  </template>
                  <span>
                    <img :src="variableF.imagenAyuda" alt="avatar" />
                  </span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </v-container>
      </v-form>
      <div v-if="deshabilitado === false">
        <serie-formularios ref="componenteSerie" v-if="banderaFormularioSerie"></serie-formularios>
      </div>
      <div
        v-if="getVariablesFormularios!=[] && deshabilitado==false"
        class="contenedorBotones"
        style="position: initial; width: 100%; justify-content: space-between;"
      >
        <div>
          <button
            v-if="banderaFormularioSerie"
            class="btn elevation-2"
            @click="$refs.componenteSerie.agregarFormulario()"
          >Agregar</button>
        </div>
        <div>
          <!-- <button
            type="button"
            class="btn elevation-2"
            @click="construirArrayVariablesActualizar()"
          >
            <v-icon>mdi-content-save-outline</v-icon>
            <span>Guardar</span>
          </button> -->
          <v-btn  class="btnPrincipal btnGuardar"  @click="construirArrayVariablesActualizar()" id="btnGuardarEnTarjeta">
                <v-icon class="ocultarMostrarIcono" color="white">save</v-icon>
                  <span style="color:white;">Guardar</span>
          </v-btn>
          <!-- <button
            type="button"
            v-if="borrable"
            @click.once="eliminarFormulario($store.getters.getIdFormulario)"
            id="botonEliminar"
            class="btn elevation-2"
          >
            <v-icon>mdi-delete-outline</v-icon>
            <span>Eliminar</span>
          </button> -->
          <v-btn  class="btnPrincipalOutline btnEliminar" outlined rounded @click.once="eliminarFormulario($store.getters.getIdFormulario)">
                    <v-icon class="ocultarMostrarIcono">mdi-delete-outline</v-icon>
                    <span>Eliminar</span>
                  </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import metodos_comunes from "../../js/metodos_comunes";
import { actualizarFormulario } from "../../apiService/request/CrudFormulario.js";
import { eliminarFormulariosExistentes } from "../../apiService/request/CrudFormulario";
import { serverBus } from "../../main";
import moment from "moment";
import DatePicker from "../DatePicker/Datepicker";
import { crearOrdenDesdeFormulario } from "../../apiService/request/CrudOrdenes";
import Vue from "vue";
import VueYoutube from "vue-youtube";
import SerieFormularios from "../SerieFormularios/SerieFormularios";
import { crearFormulario } from "../../apiService/request/CrudFormulario";

Vue.use(VueYoutube);

// import metodos_comunes from '../../js/metodos_comunes'
export default {
  data() {
    return {
      renderizar: 0,
      cantidaElementosMostrar: 0,
      nombreFormulario: null,
      idFormulario: null,
      variablesFormulario: null,
      coleccion: null,
      arrayNumeros: [],
      valorVariable: 0,
      padding: "2% 3% 2% 3%",
      gridTemplate: "1fr 1fr 1fr",
      valid: false,
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      variablesActualizadas: [],
      cargandoComponente: true,
      options: {
        locale: "es",
        format: "YYYY/MM/DD",
        clearable: true
      },

      responsive: "embed-responsive-item",
      ancho: "100%",
      alto: "400",
      url: "https://www.youtube.com/embed/",
      video: "nkA-Tl4zv-E",
      borde: "0",
      pcompleta: null,
      tick_labels: "",
      disabledTotal:false,
      formula:'',
      formulaCopia:'',
      unirArray:[],
      hacerCalculo:true,
      calculateTotal:0,
      arrayPrueba:
      {
        "status": 200,
        "data": {
            "variables": [
                {
                    "lim_inferior": null,
                    "limites": null,
                    "obligatorio": false,
                    "tipo": "lista",
                    "lim_superior": null,
                    "grafica": null,
                    "key": "ze71ffdbea",
                    "valor": null,
                    "variable": "variable1",
                    "visible": true,
                    "lista": "Sedes",
                    "habilitado":true,
                    "nombre": "Sede",
                    "opciones_lista": [
                        {
                            "valor": "Medellín",
                            "puntaje": null
                        },
                        {
                            "valor": "Rionegro",
                            "puntaje": null
                        },
                        {
                            "valor": "Envigado",
                            "puntaje": null
                        },
                    ]
                },
                {
                    "tipo": "array_lista",
                    "lim_superior": null,
                    "grafica": null,
                    "key": "z053a5638a",
                    "valor": null,
                    "variable": "variable2",
                    "visible": true,
                    "lista": "Consultorios",
                    "nombre": "Consultorio",
                    "lim_inferior": null,
                    "limites": null,
                    "obligatorio": false,
                    "indexPadre": 0,
                    "habilitado":false,
                    "opciones_lista": [
                        {
                            "valor": "Consultorio1",
                            "puntaje": null,
                            condiciones: [{
                              lista: 'Sedes',
                              valor: 'Medellín',
                            },
                            {
                              lista: 'Sedes',
                              valor: 'Rionegro',
                            }],
                        },
                        {
                            "valor": "Consultorio2",
                            "puntaje": null,
                            condiciones: [{
                              lista: 'Sedes',
                              valor: 'Medellín',
                            }],
                        },
                        {
                            "valor": "Consultorio3",
                            "puntaje": null,
                            condiciones: [{
                              lista: 'Sedes',
                              valor: 'Envigado',
                            },
                            {
                              lista: 'Sedes',
                              valor: 'Rionegro',
                            }],
                        },
                    ]
                },
                {
                    "nombre": "Responsable",
                    "lim_inferior": null,
                    "limites": null,
                    "obligatorio": false,
                    "tipo": "array_lista",
                    "lim_superior": null,
                    "grafica": null,
                    "key": "ze7a8e353a",
                    "valor": null,
                    "variable": "variable3",
                    "visible": true,
                    "lista": "Responsables",
                    "indexPadre": 1,
                    "habilitado":false,
                    "opciones_lista": [
                        {
                            "valor": "Camila",
                            "puntaje": null,
                            condiciones: [{
                              lista: 'Consultorios',
                              valor: 'Consultorio1',
                            },
                            {
                              lista: 'Consultorios',
                              valor: 'Consultorio2',
                            },
                            {
                              lista: 'Consultorios',
                              valor: 'Consultorio3',
                            }],
                        },
                        {
                            "valor": "Andres",
                            "puntaje": null,
                            condiciones: [
                            {
                              lista: 'Consultorios',
                              valor: 'Consultorio2',
                            },
                            {
                              lista: 'Consultorios',
                              valor: 'Consultorio3',
                            }],
                        },
                        {
                            "valor": "Hania",
                            "puntaje": null,
                            condiciones: [{
                              lista: 'Consultorios',
                              valor: 'Consultorio1',
                            },
                            {
                              lista: 'Consultorios',
                              valor: 'Consultorio2',
                            }],
                        },
                        {
                            "valor": "Stiben",
                            "puntaje": null,
                            condiciones: [
                            {
                              lista: 'Consultorios',
                              valor: 'Consultorio2',
                            }],
                        }
                    ]
                },
                {
                    "key": "z6f95772ba",
                    "valor": null,
                    "variable": "variable4",
                    "visible": true,
                    "lista": null,
                    "nombre": "Nombre",
                    "lim_inferior": null,
                    "limites": null,
                    "obligatorio": false,
                    "tipo": "string",
                    "lim_superior": null,
                    "grafica": null,
                    "habilitado":true,
                },
                {
                    "lim_inferior": null,
                    "limites": null,
                    "obligatorio": false,
                    "tipo": "array_lista_multiple",
                    "lim_superior": null,
                    "grafica": null,
                    "key": "zd3c14beaa",
                    "valor": null,
                    "variable": "variable5",
                    "visible": true,
                    "lista": "Procedimientos",
                    "nombre": "Procedimiento",
                    "indexPadre": 0,
                    "habilitado":false,
                    "opciones_lista": [
                        {
                            "valor": "Espirometría",
                            "puntaje": null,
                            condiciones: [{
                              lista: 'Sedes',
                              valor: 'Medellín',
                            },
                            {
                              lista: 'Sedes',
                              valor: 'Envigado',
                            }],
                        },
                        {
                            "valor": "PLG",
                            "puntaje": null,
                            condiciones: [{
                              lista: 'Sedes',
                              valor: 'Medellín',
                            },
                            {
                              lista: 'Sedes',
                              valor: 'Rionegro',
                            }],
                        },
                        {
                            "valor": "Capnografía",
                            "puntaje": null,
                            condiciones: [{
                              lista: 'Sedes',
                              valor: 'Medellín',
                            },
                            {
                              lista: 'Sedes',
                              valor: 'Envigado',
                            },
                            {
                              lista: 'Sedes',
                              valor: 'Rionegro',
                            }],
                        }
                    ]
                },
            ],
            "key": "nuevo_formulario",
            "coleccion": "formularios"
        },
        "message": "Formulario leído"
      }
 
    };
  },
  beforeUpdate() {
    // console.log("deshabilitado:", this.deshabilitado);
  },
  components: {
    DatePicker,
    SerieFormularios
  },
  props: {
    texto_introductorio: {
      type: String,
      default: null
    },
    /**
     * El parámetro caso, va permitir trabajar con diferentes variables del store
     * En el caso del formulario <informacion_general>, el valor va ser 2
     * El valor de 1 es el por defecto del componente
     */
    banderaFormularioSerie: {
      type: Boolean,
      default: false
    },
    caso: {
      type: Number,
      default: 1
    },
    terminar: {
      type: Boolean,
      default: true
    },
    borrable: {
      type: Boolean,
      default: true
    },
    banderaSeguimiento: {
      type: Boolean,
      default: false
    },
    deshabilitado: {
      type: Boolean,
      default: false
    },
    comprobarCamposObligatorios: {
      type: Boolean,
      default: false
    },
    verCompleto: {
      type: Boolean,
      default: false
    },
    banderaTarjetaMiniaturaExpandible: {
      type: Boolean,
      default: false
    }
  },
  created() {
    
    
    if (this.caso == 2) {
      this.idFormulario = this.$store.getters.getIdFormularioInfoGeneral;
      this.nombreFormulario = this.$store.getters.getNombreFormularioInfoGeneral;
      this.variablesFormulario = this.$store.getters.getVariablesFormulariosInfoGeneral;
      this.coleccion = this.$store.getters.getColeccionInfoGeneral;
    } else {
      this.idFormulario = this.$store.getters.getIdFormulario;
      this.nombreFormulario = this.$store.getters.getNombreFormulario;
      this.variablesFormulario = this.$store.getters.getVariablesFormularios;
      this.coleccion = this.$store.getters.getColeccion;
      // console.log(this.arrayPrueba);
      // this.$store.dispatch("setVariablesFormularios", this.arrayPrueba.data.variables);
    }
  },
  mounted() {
    
    // this.$store.dispatch("setVariablesFormularios", this.arrayPrueba.data.variables);
  },
  computed: {
    getVariablesFormularios() {
      let m_variablesFormularios = null;
      if (this.caso == 2) {
        m_variablesFormularios = this.$store.getters
          .getVariablesFormulariosInfoGeneral;
      } else {
        m_variablesFormularios = this.$store.getters.getVariablesFormularios;
      }
      const self = this;
      if (m_variablesFormularios != null) {
        m_variablesFormularios.map(variable => {
          if (variable.nombre.length >= self.valorVariable) {
            self.valorVariable = variable.nombre.length;
            if (self.valorVariable >= 22 && self.valorVariable <= 30) {
              self.gridTemplate = "1fr 1fr";
            } else if (self.valorVariable > 30) {
              self.gridTemplate = "1fr";
            } else {
              self.gridTemplate = "1fr 1fr 1fr";
            }
          }
          if (self.verCompleto === true) {
            self.gridTemplate = "1fr 1fr 1fr";
          }
          if (self.banderaSeguimiento) {
            self.gridTemplate ="1fr";
          }
          if(variable.ecuacion) {
          this.disabledTotal = true;
          if (variable.valor != null) {
            this.calculateTotal = variable.valor;
          }
          }
        });
        if(this.$store.getters.getNombreFormulario== "Texto resumen IPSA"){
          this.gridTemplate = "1fr"
        }
      }
      this.variablesWithEquations(m_variablesFormularios)
      return m_variablesFormularios;
    },
    getNumeroCampo() {
      if (
        this.$store.getters.getCampoIngresado != null &&
        this.$store.getters.getNumeroCampo != null &&
        this.$store.getters.getVariablesFormularios != null
      ) {
        let variablesFormularios = this.$store.getters.getVariablesFormularios;
        variablesFormularios[
          this.$store.getters.getNumeroCampo - 2
        ].valor = this.$store.getters.getCampoIngresado;
        this.$store.dispatch("setVariablesFormularios", []);
        this.$store.dispatch("setVariablesFormularios", variablesFormularios);
      }
      return this.$store.getters.getNumeroCampo;
    },
    player() {
      return this.$refs.youtube.player;
    }
  },
  watch: {
    getVariablesFormularios() {
    },
    getNumeroCampo() {},
    comprobarCamposObligatorios(valor) {
      if (valor === true) {
        if (this.$refs.form.validate()) {
          this.$emit("cerrarSinActualizar");
        }
      }
      this.$emit("actualizarBandera");
    }
  },
  methods: {
    posicionSeleccionLista(formulario,index){
      formulario[index].seleccion={'lista':formulario[index].lista,'valor':formulario[index].valor}
      this.$store.dispatch("setVariablesFormularios", formulario);
      this.construccionOpcionesLista(index)
      this.calcularTotal()
    },
    construccionOpcionesLista(index){
      const condiciones=this.$store.getters.getVariablesFormularios[index].seleccion
      const arrayVariables=this.$store.getters.getVariablesFormularios
      const self= this
      arrayVariables.map((elemento,index1)=>{
        if(elemento.indexPadre==index){
          elemento.valor=null 
          self.posicionSeleccionLista(arrayVariables,index1)
          elemento.lista_seleccionada= elemento.opciones_lista.filter(x => x.condiciones.some(e => e.lista === condiciones.lista && e.valor === condiciones.valor));
          elemento.habilitado=self.habilitarSelect(elemento.lista_seleccionada)
        }
      })
      this.$store.dispatch("setVariablesFormularios", arrayVariables);
      this.renderizar += 1
    },
    habilitarSelect(lista_seleccionada){
      if(lista_seleccionada.length>0){
        return true
      }
      return false
    },
    filterJsonV3 (variables, filterValue, value) {
      return variables.filter(element => element[filterValue] == value);
    },
    variablesWithEquations(arrayVariables){
      const variablesWithEquations= this.filterJsonV3(arrayVariables, 'tipo', 'formula');
      if(variablesWithEquations.length !== 0){
        variablesWithEquations.map(e => {
          const variables = [];   
          const index = parseInt(e.variable.replace('variable', '')) - 1 ;
          if(Object.values(e['variable_formula']).length!=0){
            Object.values(e['variable_formula']).map(variable => {
              const variableToEquation = this.filterJsonV3(arrayVariables, 'variable', variable.valor);
              variables[parseInt(variable.nombre.replace('v', '')) - 1] = {nombre: variable.nombre, valor: variableToEquation[0].valor};
            });
            let equation = e.formula;
            variables.map(v => {
              if(v.valor!=null){
                equation = equation.replace(new RegExp(v.nombre, 'g'), v.valor);
              }  
            })
            if(!equation.includes('v')){
              e.valor = eval(equation);
              this.$store.getters.getVariablesFormularios[index]=e
            }
          }
        });
      }
    },
    //  Funcion para calcular el numero de opciones seleccionadas dependiendo de la cantidad del texto seleccionado
    calcularCantidadSeleccionada(arrayValores,formulario,index) {
      this.posicionSeleccionLista(formulario,index)
      let maximaLongitud = 0;
      arrayValores.map(variable => {
        if (variable.length >= maximaLongitud) {
          maximaLongitud = variable.length;
          if (maximaLongitud >= 7) {
            this.cantidaElementosMostrar = 0;
          } else if (maximaLongitud >= 4 && maximaLongitud < 7) {
            this.cantidaElementosMostrar = 1;
          } else {
            this.cantidaElementosMostrar = 2;
          }
        }
      });
      this.calcularTotal();
      return arrayValores;
    },
    calcularNumeros(valorMayor,valorMenor) {
      for (let i = valorMenor; i <= valorMayor; i++) {
        this.arrayNumeros.push(i.toString());
      }
      console.log('hola desde slider');
      if (this.disabledTotal) {
        this.calcularTotal();
      }
    },
    playVideo() {
      this.player.playVideo();
    },
    playing(index) {
      let variables = this.$store.getters.getVariablesFormularios;
      variables[index].valor = "Sí";
      this.$store.dispatch("setVariablesFormularios", variables);
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD");
    },
    fechaFormateada(index) {
      this.variablesActualizadas[index];
      this.dateFormatted = this.formatDate(this.date);
    },
    actualizarFormularioActualPanel: function() {
      if (this.$store.getters.getBanderaBotonMas == false) {
      } else {
        this.$store.dispatch("setBanderaBotonMas", false);
      }
    },
    construirArrayVariablesActualizar() {
      this.$store.dispatch("setCargando", true);
      document.getElementById('btnGuardarEnTarjeta').disabled = true;
      const validacionFormulario = this.$refs.form.validate();
      let validacionSerieFormularios = true
      if (
        this.banderaFormularioSerie && 
          this.$refs.componenteSerie &&
          this.$refs.componenteSerie.$refs &&
          this.$refs.componenteSerie.$refs.formularioSerie
        ) {
        validacionSerieFormularios = this.$refs.componenteSerie.$refs.formularioSerie.validate();
      } 
      if (validacionFormulario && validacionSerieFormularios) {
        
        const arrayActualizar = [];
        let m_variablesFormularios = null;
        if (this.caso == 2) {
          m_variablesFormularios = this.$store.getters
            .getVariablesFormulariosInfoGeneral;
        } else {
          m_variablesFormularios = this.$store.getters.getVariablesFormularios;
        }

        console.log('this.$store.getters.getVariablesFormularios',this.$store.getters.getVariablesFormularios);
        m_variablesFormularios.map((variable) =>{
          if (variable.valor != null) {
            if (variable.tipo == "numero") {
              console.log('variable',m_variablesFormularios);
              const jsonActualizar = {
                nombre: variable.variable,
                valor: Number(variable.valor)
              };
              arrayActualizar.push(jsonActualizar);
            } else if(!variable.ecuacion){
              console.log('estoy en guardar');

              const jsonActualizar = {
                nombre: variable.variable,
                valor: variable.valor
              };
              arrayActualizar.push(jsonActualizar);
            }
          console.log('arrayActualizar',arrayActualizar);
          }
          if(variable.ecuacion) {
              console.log('estoy en guardar');
              const jsonActualizar = {
                nombre: variable.variable,
                valor: variable.tipo == "numero"
                  ? Number(this.calculateTotal)
                  : this.calculateTotal,
              };
            arrayActualizar.push(jsonActualizar);
          }
        });
        if (this.caso == 2) {
          this.$store.dispatch(
            "setVariablesActualizadasInfoGeneral",
            arrayActualizar
          );
        } else {
          this.$store.dispatch("setVariablesActualizadas", arrayActualizar);
        }
        this.actualizarFormularioActual();
      } else {
        document.getElementById('btnGuardarEnTarjeta').disabled = false;
        this.$store.dispatch("setCargando", false);
      }
    },
    async actualizarFormularioActual() {
      try {
        let respuesta = null;
        if (this.caso == 2) {
          respuesta = await actualizarFormulario(
            this.$store.getters.getIdFormularioInfoGeneral,
            this.$store.getters.getNombreFormularioInfoGeneral,
            this.$store.getters.getVariablesActualizadasInfoGeneral,
            this.$store.getters.getColeccionInfoGeneral, 
            this.$store.state.provider_email
          );
        } else {
          respuesta = await actualizarFormulario(
            this.$store.getters.getIdFormulario,
            this.$store.getters.getNombreFormulario,
            this.$store.getters.getVariablesActualizadas,
            this.$store.getters.getColeccion,
            this.$store.state.provider_email
          );
        }
        await this.crearSerieFormularios();
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      } finally {
        if (this.caso == 1) {
          if (this.$store.getters.getBanderaFormularioCreadoPanel == false) {
            this.$store.dispatch("setMensajeChatBox", "Terminar");
          } else {
            this.$store.dispatch("setBanderaFormularioCreadoPanel", false);
          }
        }
        if (this.caso == 2) {
          this.$store.dispatch("setIdFormularioInfoGeneral", null);
          this.$store.dispatch("setVariablesFormulariosInfoGeneral", []);
          this.$store.dispatch("setVariablesActualizadasInfoGeneral", []);
          this.$store.dispatch("setNombreFormularioInfoGeneral", null);
          this.$store.dispatch("setCampoIngresadoInfoGeneral", null);
          this.$store.dispatch("setNombreCampoInfoGeneral", null);
        } else {
          this.$store.dispatch("setIdFormulario", null);
          this.$store.dispatch("setVariablesFormularios", []);
          this.$store.dispatch("setVariablesActualizadas", []);
          this.$store.dispatch("setNombreFormulario", null);
          this.$store.dispatch("setCampoIngresado", null);
          this.$store.dispatch("setNombreCampo", null);
        }
        this.$emit("formularioActualizado");
        this.$store.dispatch("setCargando", false);
      }
    },
    async crearSerieFormularios() {
      if (
        this.$refs &&
        this.$refs.componenteSerie &&
        this.$refs.componenteSerie.$refs &&
        this.$refs.componenteSerie.$refs.formularioSerie &&
        this.$refs.componenteSerie.$refs.formularioSerie.validate()
      ) {
        let respuesta_crear = null;
        let respuesta = null;
        return await Promise.all(
          this.$store.getters.getSerieFormularios.map(async formulario => {
            respuesta_crear = await crearFormulario(
              this.$store.getters.getColeccion,
              this.$store.getters.getNombreFormulario,
              this.$store.state.provider_email,
              "momento" + this.$store.getters.getMomentoActual,
              parseInt(this.$store.getters.getCedulaPaciente),
              'encuentros',
              this.$store.getters.getId // Este es el id relacionado con el docId del encuentro
            );
            const variables_mapeadas = this.mapearVariables(
              formulario.variables
            );
            respuesta = await actualizarFormulario(
              respuesta_crear.data.data.docId,
              this.$store.getters.getNombreFormulario,
              variables_mapeadas,
              this.$store.getters.getColeccion,
              this.$store.state.provider_email
            );
          })
        );
      }
    },
    mapearVariables(m_variablesFormularios) {
      const arrayActualizar = [];
      m_variablesFormularios.map(function(variable) {
        if (variable.valor != null) {
          if (variable.tipo == "numero") {
            const jsonActualizar = {
              nombre: variable.variable,
              valor: Number(variable.valor)
            };
            arrayActualizar.push(jsonActualizar);
          } else {
            const jsonActualizar = {
              nombre: variable.variable,
              valor: variable.valor
            };
            arrayActualizar.push(jsonActualizar);
          }
        }
      });
      return arrayActualizar;
    },
    async eliminarFormulario() {
      this.$store.dispatch("setCargando", true);
      const respuesta = await eliminarFormulariosExistentes(
        this.$store.getters.getIdFormulario,
        this.$store.getters.getNombreFormulario
      );
      serverBus.$emit("formularioActualizadoExitosamenteMomento", respuesta);
      this.banderaMostrarTarjetaCompleta = false;
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", respuesta);
      if (
        this.$store.getters.getBanderaFormularioCreadoPanel == false &&
        this.terminar
      ) {
        this.$store.dispatch("setMensajeChatBox", "Terminar");
      } else {
        this.$store.dispatch("setBanderaFormularioCreadoPanel", false);
      }
      serverBus.$emit("formularioActualizado", respuesta.data);
      this.regresar();
      if (!this.$store.getters.getBanderaBotonMas) {
        this.$store.dispatch("setMensajeChatBox", "Terminar");
      }
      this.$emit("formularioActualizado");
      this.$store.dispatch("setCargando", false);
    },
    regresar: function() {
      // this.banderaHabilitarInputs=false,
      this.$store.dispatch("setVariablesFormularios", []);
      this.$store.dispatch("setBanderaFormularioExistenteAbierto", false);
      serverBus.$emit("banderaHabilitarInputs", this.banderaHabilitarInputs);
      serverBus.$emit("formularioActualizadoExitosamenteMomento");
      this.banderaMostrarTarjetaCompleta = false;
    },
    calcularTotal() {
        console.log('hola ');

      if (
        this.$store.getters.getVariablesFormularios !== undefined &&
        this.$store.getters.getVariablesFormularios.length > 0 &&
        this.disabledTotal
      ) {
        console.log('hola 2');
        console.log(this.$store.getters.getVariablesFormularios);
        this.$store.getters.getVariablesFormularios.map((variable) => {
          if (variable.ecuacion) {
            this.formula = variable.ecuacion;
            this.formulaCopia = JSON.parse(this.formula);
            console.log('this.formulacopia', this.formulaCopia);
            this.formulaCopia.forEach((element, i) => {
              const valor = this.$store.getters.getVariablesFormularios.find(
                (e) => e.variable === element
              );
              if (
                valor !== undefined &&
                valor.tipo !== "lista" &&
                valor.valor !== null
              ) {
                this.formulaCopia[i] = valor.valor;
              } else if (
                valor !== undefined &&
                valor.tipo === "lista" &&
                valor.valor !== null
              ) {
                const puntaje = valor.opciones_lista.find(
                  (e) => e.valor === valor.valor
                );
                this.formulaCopia[i] = puntaje.puntaje;
              }
              this.unirArray = this.formulaCopia.join("");
            });
          }
        });
        console.log('this.unirArray',this.unirArray);
        this.hacerCalculo = this.unirArray.includes("variable");
        console.log('hacerCalculo', this.hacerCalculo);
        if (!this.hacerCalculo) {
          try {
            this.calculateTotal =
              eval(this.unirArray) !== Infinity ? eval(this.unirArray) : "";
              console.log('calcualrTotal',this.calculateTotal);
          } catch (error) {
            console.log(error);
          }
        }
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/base/tipografia";
.contenedorTarjetaNuevasMomento {
  height: 100%;
  width: 100%;
  transition: 0.3s;
  margin: auto;
  padding-bottom: 5%;
  .nombreRadioGroup {
    overflow-wrap: break-word;
    height: auto;
    text-align: left;
    font-size: 16px;
    line-height: 18px;
    min-width: 50%;
    color: $gris;
  }
  .tarjeta {
    margin-top: 15px;
    width: 100%;
    height: auto;
    padding: 1.25vw;
    position: sticky;
    border-radius: 8px;
    z-index: 0;
    border-left: 5px solid #3d88c4;
    .tituloFormulario {
      font-size: 25px;
      text-transform: capitalize;
      color: #00000061;
      font-weight: 700;
    }
    .container {
      max-width: 1600px;
      #DivInformacionResumen {
        position: relative;
        min-width: 30% !important;
        margin: 0%;
        height: auto;
        padding: 2.2%;
        padding-left: 0;
        align-self: center;
      }
    }
  }
  .lineaIzquierda {
    border-left: none;
  }
  .grid {
    display: grid;
    position: sticky;
  }

  .contenedorBotones {
    display: inline-flex;

    margin-bottom: 15px;
  }
  .espacioDivider {
    margin-top: 18px;
  }
  .contenedorTextoLimites {
    display: flex;
    justify-content: space-between;
    // @extend %texto-alternativo;

    .v-input__control {
      .v-messages {
        min-height: 0 !important;
      }
    }
    .textoLimites {
      color: rgba(0, 0, 0, 0.54);
      max-width: 45%;
      font-size: 14px;
    }
  }
  .lineado {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 16px;
  }
  .tamanoSlider {
    width: 80%;
    margin: 0 auto;
    color: grey;
    font-size: 12px !important;
  }
  .btnGuardar{
    color: white;
  }
  // .btn {
  //   margin-left: 10px;
  //   width: 80px;
  //   .v-icon {
  //     display: none;
  //   }
  // }
  // .botones {
  //   font-family: "Nunito", sans-serif;
  //   color: #646a6a;
  //   font-weight: bold;
  //   // font-size: 18px;
  //   margin-right: 1.25vw;
  //   width: 100px;
  //   border-radius: 20px;
  //   height: 32px;
  // }

  // .botones:hover {
  //   background: #d4d1d163;
  // }
  #botonEliminar {
    opacity: 0.5;
  }

  @include pantalla-pequena {
    .contenedorBotones {
      display: flex;
      justify-content: center !important;
      text-align: center;
    }
    .botones {
      font-size: 14px;
      width: 80px;
      height: 25px;
    }
    .btnEliminar{
      margin-bottom: 10px;
    }
    .btnGuardar{
      margin-bottom: 10px;
    }
  }
  // @media only screen and (max-width: 1666px) {
  //   .tarjeta .v-input {
  //     font-size: 15px;
  //     // @extend %texto-alternativo;
  //   }
  // }
  @include pantalla-pequena {
    .v-form .grid {
      grid-template-columns: 1fr !important;
      padding: 0;
      // .v-input {
      // @extend %texto-alternativo;
      // font-size: 12px;
      // }
    }
    .lineado {
      font-size: 15px;
    }
    .contenedorTextoLimites {
      .textoLimites {
        font-size: 11px;
      }
    }
  }
  &.banderaSeguimiento {
    margin: 0;
    .tarjeta {
      width: 100%;
      padding: 0;
      box-shadow: none;
      .v-form .grid {
        padding: 5px;
        // .v-input {
        // @extend %texto-alternativo;
        // font-size: 15px;
        // }
      }

      // @media only screen and (max-width: 1666px) {
      //   .v-form .grid {
      //     grid-template-columns: 1fr !important;
      //     padding: 0;
      //     // .v-input {
      //     // @extend %texto-alternativo;
      //     // font-size: 12px;
      //     // }
      //   }
      // }
    }
  }
  @include pantalla-celular {
    // .btn {
    //   span {
    //     display: none;
    //   }
    //   .v-icon {
    //     display: contents;
    //   }
    // }
  }
  &.banderaTarjetaMiniaturaExpandible {
    margin: 0;
    width: 100%;
    .tarjeta {
      margin: 0;
      width: 100%;
      padding: 0;
      .v-form .grid {
        grid-template-columns: 1fr !important;
        padding: 5%;
      }
    }
    .contenedorBotones {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TarjetasNuevasMomento/TrajetasNuevasMomento.vue